import React from "react";
import { renderToString } from "react-dom/server";
import { PinSvg } from "./PinSvg";

export type MultipleMapPinType = {
  type: "multiple";
  count: number;
}

export const getMultipleMapPin = (pin: MultipleMapPinType) => {
  const element = document.createElement("div");
  element.innerHTML = renderToString(<MultiplePin count={pin.count} />);
  return element;
}

interface MultiplePinProps {
  count: number;
}

export const MultiplePin = ({ count }: MultiplePinProps) => {
  return <div className="google-map-pin-wrapper">
    <div className="google-map-pin-content google-map-pin-content-multiple">{count}</div>
    <PinSvg width={27} height={43} empty={false} fillColor="white" />
  </div>
}